import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  const resourcePath = resource.type === 'product' ? 'ecommerce' : 'events'
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/${resourcePath}/categories/${resource.id}/edit`} />
  ]
}

export default buildMenuItems
